/** The footer: link columns, bottom row and the giant wordmark. */
import codeltdLogo from '@/assets/images/codeltd-logo.png'
import { CODELTD_URL, SITE_EMAIL } from '@/data/links'

import { ACTIONS } from './site'

export const FOOTER = {
  columns: [
    {
      title: 'Product',
      links: [
        { label: 'Panels', href: '/#panels' },
        { label: 'Why MeetNPlan', href: '/#why' },
        { label: 'FAQ', href: '/#faq' },
        { label: 'User guide', href: '/guide' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'Contact', href: '/contact' },
        { label: 'Updates', href: '/updates' },
        { label: SITE_EMAIL, href: `mailto:${SITE_EMAIL}` },
        ACTIONS.signIn,
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy policy', href: '/privacy' },
        { label: 'Terms of service', href: '/terms' },
        { label: 'Cookie policy', href: '/cookies' },
      ],
    },
  ],
  bottomLinks: [
    { label: 'Privacy', href: '/privacy' },
    { label: 'Terms', href: '/terms' },
    { label: 'Cookies', href: '/cookies' },
  ],
  copyright: '© 2026 MeetNPlan',
  // The company behind MeetNPlan: its logo after the copyright, linking out.
  maker: {
    label: 'A product of',
    name: 'Code LTD',
    logo: codeltdLogo,
    href: CODELTD_URL,
  },
  wordmark: 'MeetNPlan',
}
